import { render, staticRenderFns } from "./purchase-list.vue?vue&type=template&id=3328b4be&"
import script from "./purchase-list.vue?vue&type=script&lang=js&"
export * from "./purchase-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports